import QuestionnaireResponseAnswersTable from 'src/javascripts/components/tables/QuestionnaireResponseAnswersTable';
import DefaultTable from 'src/javascripts/components/tables/DefaultTable';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import ScrollToTag from 'src/javascripts/components/nav/ScrollToTag';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {genericDisplayTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');


export default class QuestionnairesResponsesAnswersIndex {

  constructor() {}

  render() {

	  // Set account id
	  const accountUrl = $('body').attr('data-account-url');

    // Set scroll and reload
    $('.reload-by-table').click(function() {
      let scrollFilter = $('#metricTablesBody').scrollTop();
      let metricTableId = $(this).data('metric-table-id');
      let url = '/' + accountUrl + '/questionnaires/metric_tables';
      let params = {};
      params['metric_table_id'] = metricTableId;
      params['sp'] = scrollFilter;
      Turbo.visit(url + '?' + $.param(params));
    })

    // Scroll templates container on load
    let p = $('#metricTablesBody').data("scroll-p");
    if (typeof p !== "undefined") {
      $('#metricTablesBody').scrollTop(p);
    }

    // Search metric tables
    $("#search_data_tables").on("keyup", function() {
      let val = $(this).val().toLowerCase();
      $("#metric_tables_list .list-item").filter(function() {
        let t = $(this).data('table-name').toLowerCase();
        if (t.indexOf(val) === -1) {
          $(this).removeClass('d-flex').addClass('d-none');
        } else {
          $(this).removeClass('d-none').addClass('d-flex');
        }
      });
    });

    // Expand sidebar on click
    $('#metric_tables_list .list-item').click(function() {
      let group = $(this).data('group');
      $('#metric_tables_list .list-item[data-group-parent="' + group + '"]').toggleClass('minimized');
    })

	  // Questionnaires and companies search
	  filterTypeahead('.companies-search', 'companies', '/' + accountUrl + '/companies/search_share_classes?', 382, 'generic');
	  filterTypeahead('#questions_search', 'questions', '/' + accountUrl + '/questionnaires/questions/search?', 282, 'generic');
	  filterTypeahead('#responses_search', 'responses', '/' + accountUrl + '/questionnaires/responses/search?', 403, 'generic');

    // Render table
    if ( $('#questionnaire_response_answer_trends_table_wrapper').length === 0 ) {
      let table = new QuestionnaireResponseAnswersTable($('#questionnaire_response_answer_trends_table'));
      $.when( table.render() ).then( status => table.setUp('questionnaire_response_answer_trends_table') )
    }

    // Render table
    if ( $('#questionnaire_changes_table_wrapper').length === 0 ) {
      let table = new DefaultTable($('#questionnaire_changes_table'));
      $.when( table.render() ).then( status => table.setUp('questionnaire_changes_table') )
    }

    // Expand when click on table of contents item
    $('.sticky-sidebar a.scroll-to-section').click(function(e) {
      e.preventDefault();
      let sectionId = $(this).attr('data-tag');
      setTimeout(function() {
        ScrollToTag(sectionId);  
      }, 500);
    });

    // Auto-focus on expanding dropdown
    $('.dropdown').on('shown.bs.dropdown', function() {
    	$(this).find('.typeahead').focus();
    });

    // Reload with attrs
    let reloadWithSelectedParams = function() {
	    let url = '/' + accountUrl + '/questionnaires/responses/answers';
      let params = {};
      params['company_id'] = $('#questionnaire_response_answer_trends_table').attr('data-company-id');
      params['questionnaire_id'] = $('#questionnaire_response_answer_trends_table').attr('data-questionnaire-id');
	    params['question_id'] = $('#questionnaire_response_answer_trends_table').attr('data-question-id');
      Turbo.visit(url + '?' + $.param(params));
    }

    // On selecting an item
    $('.companies-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    	$('#questionnaire_response_answer_trends_table').attr('data-company-id', suggestion.company_id);
    	reloadWithSelectedParams();
    })

    // On selecting a questionnaire
    $('.questionnaires-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    	$('#questionnaire_response_answer_trends_table').attr('data-questionnaire-id', suggestion.value);
    	reloadWithSelectedParams();
    })

	  // On selecting a question
	  $('#questions_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
	    $('#questionnaire_response_answer_trends_table').attr('data-question-id', suggestion.value);
    	reloadWithSelectedParams();
	  })


	  // On selecting a response
	  $('#responses_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
	    let rId = suggestion.value;
	    
	    // Download excel formatted data
	    let url = "/" + accountUrl + "/data-collection/responses/" + rId + "/answers";
		  $.ajax({
		    type: "GET",
		    dataType: "script",
		    url: url + '.js'
		  });

		  // Blur
		  $(this).typeahead('val','').blur();

	  });

  }

}